<template>
  <div class="content-container">
    <!-- Lewy panel z filtrami statystyk -->
    <filter-statistic-data />
    <div class="content-wrap">
      <!-- Górne menu -->
      <TopMenu />
      <!-- Główna sekcja z danymi/statystykami, przekazujemy kroki, eventy sterujące i stan wyniku -->
      <statistics-data
        :step="step"
        :isResult="isResult"
        @nextStep="nextStep"
        @previousStep="previousStep"
        @clear="clear"
      />
    </div>
  </div>
</template>

<script>
import { nextTick } from "vue";
import TopMenu from "../components/TopMenu.vue";
import { useStatisticStore } from "../stores/statistic";
import StatisticsData from "@/components/StatisticsData.vue";
import FilterStatisticData from "@/components/FilterStatisticData.vue";

export default {
  name: "StatisticView",
  components: {
    TopMenu,
    StatisticsData,
    FilterStatisticData,
  },
  setup() {
    // Pinia store z obsługą kroków statystyk
    const statistic = useStatisticStore();
    // Start zawsze od pierwszego kroku
    statistic.step = 1;
    return {
      statistic,
    };
  },
  data() {
    return {
      // Kopia aktualnego kroku oraz stanu wyniku (czy pokazywać statystyki)
      step: this.statistic.step,
      isResult: this.statistic.isResult,
    };
  },
  methods: {
    // Synchronizuje krok ze store (możesz wywołać jakby ktoś zmienił krok gdzieś indziej)
    getCurrentStep() {
      this.step = this.statistic.step;
    },
    // Przejście do następnego kroku statystyk (obsługuje wyzerowanie isResult)
    async nextStep() {
      if (this.step == 3) {
        this.statistic.setResultState(false); // Przedostatni krok – czyści wynik
        this.isResult = false;
        await nextTick(); // Upewnij się że render będzie aktualny
      }
      this.step = this.statistic.nextStep(); // Zmiana kroku przez akcję store
      this.isResult = this.statistic.isResult;
    },
    // Przejście do poprzedniego kroku
    previousStep() {
      this.step = this.statistic.previousStep();
    },
    // Reset – wraca do początku i czyści stan wyniku
    clear() {
      this.statistic.clear();
      this.step = this.statistic.step;
      this.isResult = this.statistic.isResult;
    },
  },
};
</script>

<style scoped>
.content-container {
  background-color: #f5f4f2;
}
</style>
